// extracted by mini-css-extract-plugin
module.exports = {"actorList":"SummaryActors_actorList__iBpbL","actorItem":"SummaryActors_actorItem__nC00f"};